import { apiClient } from '../../client'
import type { NpdLookupOption, NpdLookupPayload } from './npd-stores.repository'

class NpdSkusRepository {
  async getSelected(npdBatchId: number): Promise<{ skus: NpdLookupOption[] }> {
    return apiClient.get<{ skus: NpdLookupOption[] }>(`/npd-skus/selected/${npdBatchId}`, true, { silent: true })
  }

  async lookup(data: NpdLookupPayload): Promise<NpdLookupOption[]> {
    return apiClient.post<NpdLookupOption[]>('/npd-skus/lookup', data, true, { silent: true })
  }

  async sync(npdBatchId: number, skuIds: number[]): Promise<{ message: string; count: number }> {
    return apiClient.post<{ message: string; count: number }>('/npd-skus/sync', {
      npd_batch_id: npdBatchId,
      sku_ids: skuIds,
    })
  }
}

export const npdSkusRepository = new NpdSkusRepository()
